import React from 'react';
import { HashLink } from 'react-router-hash-link';



const NavLinks = () => {
    return (
        <>
            <HashLink className="px-2 font-extrabold text-gray-500 hover:text-blue-900" smooth to="/about#">
                About
            </HashLink>
            <HashLink className="px-2 font-extrabold text-gray-500 hover:text-blue-900" smooth to="/services#">
                Services
            </HashLink>
            
            <HashLink className="px-2 font-extrabold text-gray-500 hover:text-blue-900" smooth to="/projects#">
                Projects
            </HashLink>
            {/* <HashLink className="px-4 font-extrabold text-gray-500 hover:text-blue-900" smooth to="/gallery#">
                Gallery
            </HashLink> */}
            
            <HashLink className="px-2 font-extrabold text-gray-500 hover:text-blue-900" to="/careers#">
                Careers
            </HashLink>
            <HashLink className="px-2 font-extrabold text-gray-500 hover:text-blue-900" to="/contact#">
                Contact Us
            </HashLink>
            {/* <HashLink className="px-2 font-extrabold text-gray-500 hover:text-blue-900" to="/gallery#">
                Gallery
            </HashLink> */}
            <HashLink className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-auto px-4 py-2 shadow-xl rounded-xl" smooth to="/faq#">
                FAQ
            </HashLink>
        </>
    )
}

export default NavLinks;
